import { render, staticRenderFns } from "./KPICards.vue?vue&type=template&id=18c838c7&scoped=true"
import script from "./KPICards.vue?vue&type=script&lang=js"
export * from "./KPICards.vue?vue&type=script&lang=js"
import style0 from "./KPICards.vue?vue&type=style&index=0&id=18c838c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c838c7",
  null
  
)

export default component.exports